
<template>
  <div class="buffer-view">
    <div ref="plot" class="buffer-chart"></div>
  </div>

</template>

<script>
import PlayerComponent from '../PlayerComponent.vue';
import { BufferLinePlot } from '../../../utils/plots';

export default {
  extends: PlayerComponent,
  name: 'PlotBuffer',
  data () {
    return {
      currentBufferSize: 0,
      schedulePush: false
    };
  },
  mounted () {
    this.plot = new BufferLinePlot(this.$refs.plot);
    this.plot.onUpdate = (lt) => {
      if (!this.ppPlayerRef) {
        return;
      }
      const now = new Date().getTime();
      const delta = (now - lt) / 1000.0;

      if (this.schedulePush) {
        const currentTime = this.ppPlayerRef.get().getPosition();
        const bufferAhead = this.ppPlayerRef.get().getBufferInfo('total').bufferedAheadOf(currentTime);
        this.plot.addSample(bufferAhead);
        this.plot.bufferAhead = bufferAhead;
        this.schedulePush = false;
      } else {
        const state = this.ppPlayerRef.get().getState();
        if (state === clpp.Player.State.PLAYING) {
          this.plot.bufferAhead = Math.max(0, this.plot.bufferAhead - delta);
        }
      }
    };
    this.plot.init();
    this.plot.start();
    this.updatePlot();
  },
  destroyed () {
    this.plot.stop();
  },
  methods: {
    updatePlot () {
      this.schedulePush = true;
    },
    initPlayer (ppPlayerRef) {
      const ppPlayer = ppPlayerRef.get();
      ppPlayer.on('videobufferchanged', this.updatePlot);
      ppPlayer.on('audiobufferchanged', this.updatePlot);
      ppPlayer.on('statechanged', this.onStateChange);
      ppPlayer.on('seeked', this.onSeeked);
      ppPlayer.on('timeupdate', this.updatePlot);
    },
    disposePlayer (ppPlayerRef) {
      const ppPlayer = ppPlayerRef.get();
      ppPlayer.off('videobufferchanged', this.updatePlot);
      ppPlayer.off('audiobufferchanged', this.updatePlot);
      ppPlayer.off('statechanged', this.onStateChange);
      ppPlayer.off('seeked', this.onSeeked);
      ppPlayer.off('timeupdate', this.updatePlot);
    },
    onSeeked () {
      if (!this.plot) return;

      const currentTime = this.ppPlayerRef.get().getPosition();
      const bufferAhead = this.ppPlayerRef.get().getBufferInfo('total').bufferedAheadOf(currentTime);
      this.plot.addSample(bufferAhead);
      this.plot.bufferAhead = bufferAhead;
    },
    onStateChange () {
      if (!this.plot) return;

      const currentTime = this.ppPlayerRef.get().getPosition();
      const bufferAhead = this.ppPlayerRef.get().getBufferInfo('total').bufferedAheadOf(currentTime);
      this.plot.addSample(bufferAhead);
      this.plot.bufferAhead = bufferAhead;

      const state = this.ppPlayerRef.get().getState();
      if (state === clpp.Player.State.ENDED) {
        this.plot.stop();
      } else {
        this.plot.start();
      }
    }
  }
};
</script>

<style lang="css" scoped>

  .buffer-view {
  }

  .buffer-chart {
  }
</style>
